/* eslint-disable unicode-bom */
import "../components/styles/contact.css";
import { useEffect } from "react";

function Contact() {
  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className="contact-wrapper">
        <div className="contact-content-left">
          <h1 className="contact-heading">Get in Touch</h1>
          <p className="contact-description">
            Want to chat or collaborate on a project? Drop me an email at{" "}
            <a
              href="mailto:abdur.rahman19@outlook.com"
              className="highlight"
            >
              abdur.rahman19@outlook.com
            </a>
            , message me on{" "}
            <a
              href="https://www.linkedin.com/in/abdur-rahman-44ba1920b/"
              target="_blank"
              rel="noopener noreferrer"
              className="highlight"
            >
              LinkedIn
            </a>
            , or schedule a quick call using the calendar.
          </p>
          <p className="contact-description">
            Let's also connect!
          </p>
        </div>

        <div className="contact-content-right">
          <div
            className="calendly-inline-widget"
            data-url="https://calendly.com/abdul4smart19/30min?hide_gdpr_banner=1&hide_event_type_details=1&primary_color=3eb489"
            style={{ minWidth: "320px", height: "550px" }}
          ></div>
        </div>
      </div>
    </>
  );
}

export default Contact;
